"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGACY_META_DETAILS_PATH = exports.META_DETAILS_PATH = exports.LEGACY_PLAYER_PATH = exports.PLAYER_PATH = void 0;
var react_router_1 = require("react-router");
exports.PLAYER_PATH = '/player/:mediaType/:metaId/:videoId';
exports.LEGACY_PLAYER_PATH = '/player/:stream/:streamTransportUrl?/:metaTransportUrl?/:type?/:id?/:videoId?';
exports.META_DETAILS_PATH = '/metadetails/:type?/:id?/:videoId?';
exports.LEGACY_META_DETAILS_PATH = '/detail/:type?/:id?/:videoId?';
var routes = [exports.PLAYER_PATH, exports.LEGACY_PLAYER_PATH, exports.META_DETAILS_PATH, exports.LEGACY_META_DETAILS_PATH].map(function (path) { return ({ path: path }); });
var getBackFallback = function (location) {
    var _a;
    var match = (_a = (0, react_router_1.matchRoutes)(routes, location)) === null || _a === void 0 ? void 0 : _a[0];
    if (match) {
        var videoId = match.params.videoId;
        var type = match.params.mediaType || match.params.type;
        var id = match.params.metaId || match.params.id;
        var isPlayer = match.route.path === exports.PLAYER_PATH || match.route.path === exports.LEGACY_PLAYER_PATH;
        if (type && id && (isPlayer || videoId)) {
            return "/metadetails/".concat(encodeURIComponent(type), "/").concat(encodeURIComponent(id)).concat(isPlayer ? '' : location.search);
        }
    }
    return '/';
};
exports.default = getBackFallback;
